import React, {useState } from 'react';
import moment from 'moment';
import { Box, Typography, IconButton, Paper, useTheme, CircularProgress } from '@mui/material';
import {TimerOutlined} from '@mui/icons-material';
import { PARCEL_ICON, DownArrowIcon, UpArrowIcon, DottedLineUp, DottedLineDown, POD_ICON } from '../assets/constants/Icons';
import dashIcon from '../assets/images/dash_icon.png';
import { DYNAMIC_USE_CASE, LUGGAGE_USE_CASE, DARK, PENDING, ASSIGNED, COD, BUTTON_PRIMARY, BUTTON_WARNING } from "../assets/constants/Constants";
import {HOME,INVOICE} from '../assets/constants/PageList';
import {getPathForNextPage, convertDurationStringToMilliseconds, getUnitLabelParams, HideValueForPodBank, isLockerBlockedForNonOperationalBank, isPodBankType} from '../lib/Utils';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonComponent from "../components/ButtonComponent";
import CustomSliderComponent from './CustomSliderComponent';
import { APP_RICH_BLACK_COLOR, APP_WHITE_COLOR } from '../assets/constants/Colors';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, PERMISSIONS_LIST } from '../assets/constants/BrowserStorageKeys';

export const LockerItemWithDetails = ({
    item,
    usecase,
    showBookingDateAndTime,
    showOpenAndCheckoutButtons,
    hideButtonsView,
    isLockerAccordionExpanded,
    onLockerAccordionStateToggle,
    LoadersetOFF,
    setLoader,
    openAndCheckoutButtonsHandler,
    initiateCodPayment,
    isReturnAndDropOff,
    hasPendingLockers,
    setLoaderMessage,
    returnedLockers,
    settings
}) => {
    const history = useHistory();
    const { t } = useTranslation();
    const theme = useTheme()
    const colorScheme = theme.palette.mode;
    const LockerBanktype = item?.locker_bank?.bank_type;
    const permissionsList = getSecureItemFromSpecificStorage(LOCAL_STORAGE, PERMISSIONS_LIST);
    const isBlockedLocker = item?.locker_door?.is_blocked || settings?.usecase_settings?.restrict_locker_operation_on_pwa?.value || isLockerBlockedForNonOperationalBank(LockerBanktype, permissionsList);
    const isLockerAssignedToPickupUser = item?.status === ASSIGNED;
    const isPaymentTypeCod = item?.payment_type === COD;
    const isPaymentStatusCompleted = item?.payment_records?.[0]?.status === 'completed';
    const isPaymentPending = isLockerAssignedToPickupUser && isPaymentTypeCod && ( !isPaymentStatusCompleted );
    const [showLoader,setShowLoader] = useState(false)
    const hasMatchedForReturn = returnedLockers?.some(locker => locker?.locker_door?.id === item?.locker_door?.id);
    
    const getBookingEndDateAndTime = () => {
        const assignedDateAndTimeInMilliseconds = moment(item?.assigned_date).valueOf();
        const selectedSlotDurationInMilliseconds = convertDurationStringToMilliseconds(item?.selected_size_pricing?.duration);

        return moment(assignedDateAndTimeInMilliseconds + selectedSlotDurationInMilliseconds).format('DD-MM-YYYY, HH:mm:ss A');
    };
    const bookingEndDateAndTime = showBookingDateAndTime ? getBookingEndDateAndTime() : null;

    const showUserDetails = () => {
        if (usecase === DYNAMIC_USE_CASE || usecase === LUGGAGE_USE_CASE) {
            return false;
        }

        return true;
    };
    const showDottedLines = () => {
        if (usecase === DYNAMIC_USE_CASE || usecase === LUGGAGE_USE_CASE) {
            return false;
        }

        return true;
    };
    const downloadInvoice = () => {
        history.push({
            pathname: getPathForNextPage(HOME, INVOICE),
            state: { lockerItem : item},

        });
    };

    return (
        showLoader ? (
            <Box className="loader">
                <CircularProgress className='loader-style' size="20px"/>
            </Box>
        ) : (
            <Paper className='LockerWrapper'>
                <Box component="button" className='lockerContainer' onClick={onLockerAccordionStateToggle}>
                    <Box className={`listItem ${isLockerAccordionExpanded ? 'no-bottom-radius' : ""} ${isBlockedLocker ? 'list-item-blocked' : null} ${item?.status === PENDING && hasMatchedForReturn ? 'listItem-dimmed' : ''}`} onClick={() => {}}>
                        <Box className="content-wrapper">
                            <Box className="content">
                                <Box className="imageGroup">
                                    {isPodBankType(LockerBanktype) ? (
                                        <POD_ICON/>
                                    ) : (
                                        <PARCEL_ICON />
                                    )}
                                </Box>
                                <Box className="contentInfo">
                                    <Typography className={`text-one ${isBlockedLocker ? 'text-one-block' : ""}`} sx={{color : theme.palette.text.primary}}>{item?.locker_bank?.name}</Typography>
                                    <Typography className={`locker-title ${isBlockedLocker ? 'locker-title-block' : ""}`} sx={{color : theme.palette.text.primary}}>{t('lockerText', getUnitLabelParams(LockerBanktype, t))}  {HideValueForPodBank(LockerBanktype, item?.locker_door?.door_no)} </Typography>
                                    <Typography className={`textline-three ${isBlockedLocker ? 'textline-three-block' : ""}`} sx={{color : theme.palette.text.primary}}>{item?.client_ref}</Typography>
                                </Box>
                            </Box>
                            {( isLockerAccordionExpanded && showUserDetails() ) && (
                                <Box className="extra-locker-details">
                                    <Box className="user-details">
                                        <Box className="initial-view">
                                            <Typography variant="h6">
                                                {item?.user?.username?.substring(0, 1).toUpperCase()}
                                            </Typography>
                                        </Box>
                                        <Box className="contentInfo">
                                            <Typography className={`text-one ${isBlockedLocker ? 'text-one-block' : ""}`} sx={{color : theme.palette.text.primary}}>{item.user?.username}</Typography>
                                            <Typography className={`locker-title ${isBlockedLocker ? 'locker-title-block' : ""}`} sx={{color : theme.palette.text.primary}}>{item.user?.email}</Typography>
                                            <Typography className={`textline-three ${isBlockedLocker ? 'textline-three-block' : ""}`} sx={{color : theme.palette.text.primary}}>{item.user?.mobile_number}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                        {( isLockerAccordionExpanded && showDottedLines() ) && (
                            <Box className="dotted-line-up">
                                <DottedLineUp />
                                <Typography className='dotted-line-text'>{t('toText')}</Typography>
                                <DottedLineDown />
                            </Box>
                        )}
                        {( !isLockerAccordionExpanded && item.isCodPaymentPending ) && (
                            <Box className="cod-view">
                                <Typography className="cod-view-text">{t('unpaidText')}</Typography>
                            </Box>
                        )}
                        {( !isLockerAccordionExpanded && showBookingDateAndTime && item?.isOverstay ) && (
                            <Box className='overstay-indicator'>
                                <Typography className='overstay-text'>{t('Overstay_text')}</Typography>
                            </Box>
                        )}
                        {( !isBlockedLocker ) && (
                            <Box className="arrow-icon">
                                <IconButton className='accordion-button'>
                                    {isLockerAccordionExpanded ? (
                                        <UpArrowIcon iconFillColor={colorScheme === DARK ? APP_WHITE_COLOR : APP_RICH_BLACK_COLOR} />
                                    ) : (
                                        <DownArrowIcon iconFillColor={colorScheme === DARK ? APP_WHITE_COLOR : APP_RICH_BLACK_COLOR}/>
                                    )}
                                </IconButton>
                            </Box>
                        )}
                    </Box>
                    {(isLockerAccordionExpanded && showBookingDateAndTime) && (
                        <Box className='booking-info-container'>
                            <Box className='info-row'>
                                <Box className={item?.isOverstay ? 'icon-container overstay' : 'icon-container'}>
                                   <TimerOutlined style={{ color: "#5E84FD", fontSize: "20px" }} />
                                </Box>
                                <Typography className='title'>{item?.isOverstay ? `${t('Overstay_text')}:` : `${t('remaining_time')}`}</Typography>
                                <Typography className='value'>{item.usageTime}</Typography>
                            </Box>
                        </Box>
                    )}
                    {isLockerAccordionExpanded && (
                        <>
                            {hideButtonsView ? null : showOpenAndCheckoutButtons ? (
                                isPodBankType(LockerBanktype) ? null : (
                                <Box className='buttons-view'>
                                        <Box className='buttons-container'>
                                                {item?.is_already_opened_once === true &&
                                                    <>
                                                    <ButtonComponent buttonId='open-without-checkout-button' handleClick={() => openAndCheckoutButtonsHandler(false, item)} title={t('openAndKeep')} type={BUTTON_PRIMARY} />
                                                    <ButtonComponent buttonId='open-with-checkout-button' handleClick={() => openAndCheckoutButtonsHandler(true, item)} title={t('openAndCheckout')} type={BUTTON_WARNING} />
                                                </>
                                                } 
                                        </Box>
                                        <Box className="buttons-container">
                                            {item?.is_already_opened_once === false && (
                                                <ButtonComponent buttonId='open-with-checkout-button' handleClick={() => openAndCheckoutButtonsHandler(false, item)} title={t('open')} type={BUTTON_PRIMARY} />
                                            )}
                                            <ButtonComponent buttonId='invoice' handleClick={() => downloadInvoice()} title={t('invoice_Details')} type={BUTTON_WARNING} />
                                        </Box>
                                </Box>
                                )
                            ) : (
                                <Box className="slider-view">
                                    {(item.isCodPaymentPending) ? (
                                        <CustomSliderComponent
                                            label={t('swipeToPay')}
                                            overlayText={t('initiatingPayment')}
                                            onSlideDone={() => initiateCodPayment(item)}
                                            extraClass={'slider cod-slider'}
                                        />
                                    ) : (
                                        <CustomSliderComponent
                                            bankDetails={`${item.locker_door?.door_no}`}
                                            onSlideDone={() => openAndCheckoutButtonsHandler(false, item)}
                                            extraClass={'slider'}
                                        />
                                    )}
                                </Box>
                            )}
                        </>
                    )}
                </Box>
            </Paper>
        )
    );
};